// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'einaBold', 'einaBold Fallback'","fontWeight":400,"fontStyle":"normal"},"className":"__className_b18140","variable":"__variable_b18140"};